module.exports = __webpack_public_path__ + "static/media/facebook_traffic_mastery.a24eb257.jpg";